module.exports = __webpack_public_path__ + "img/uaf-life.595c7321.png";